import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  setSinceLasLogout,
  setStatusSearch,
} from '../../features/order/orderSlice'

const OrderStatus = () => {
  const { order_status } = useSelector((state) => state.auth)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const orderStatusOnClickHandler = (orderKey) => {
    dispatch(setStatusSearch(orderKey))
    dispatch(setSinceLasLogout(1))

    navigate('/orders')
  }

  return (
    <div className='w-full'>
      <h1 className='text-center my-4 text-2xl leading-snug uppercase'>
        受注状況
      </h1>
      <div className='w-full flex flex-col items-center mt-8'>
        <div className='mx-auto w-[80vw] md:max-w-[600px] w-12/12 flex flex-col justify-between border-[1px] border-cyan-900'>
          <h1 className='text-center py-2 text-white text-lg bg-cyan-900 leading-snug uppercase'>
            受注状況
          </h1>
          {order_status &&
            order_status?.value?.map((stat, idx) => (
              <p
                key={idx}
                onClick={() => orderStatusOnClickHandler(idx)}
                className='text-left py-4 px-2 text-gray-700 odd:bg-gray-200 even:bg-gray-100 cursor-pointer hover:bg-gray-300'
              >
                {stat.name} ({stat.count})
              </p>
            ))}
        </div>
      </div>
    </div>
  )
}

export default OrderStatus
